import { gql } from "@apollo/client";

export const PAGE_SIZE = 30;

export const FETCH_LAB_TEST_REPORTS = gql`
  query FETCH_LAB_TEST_REPORTS(
    $offset: Int
    $limit: Int
    $q: String
    $country: String
    $expiryStatus: String
    $standardIds: [ID]
  ) {
    labTestReports(
      offset: $offset
      limit: $limit
      q: $q
      country: $country
      expiryStatus: $expiryStatus
      standardIds: $standardIds
    ) {
      total
      results {
        id
        title
        country
        issuer
        issuedDate
        expiryStatus
        expiryDate
        reportNumber
        standards {
          id
          name
        }
        products {
          id
          number
          name
          isActive
        }
        fileUrls
      }
    }
  }
`;

export const FETCH_COMPLIANCE_STANDARDS = gql`
  query FETCH_COMPLIANCE_STANDARDS {
    complianceStandards {
      id
      name
    }
  }
`;

export const FETCH_LAB_TEST_REPORT = gql`
  query FETCH_LAB_TEST_REPORT($id: ID!) {
    labTestReport(id: $id) {
      id
      title
      country
      issuer
      issuedDate
      reportNumber
      validityMonths
      validUntil
      standards {
        id
        name
      }
      products {
        id
        number
        name
      }
      fileUrls
    }
  }
`;

export const CREATE_LAB_TEST_REPORT = gql`
  mutation CreateLabTestReport(
    $title: String!
    $country: String
    $issuer: String
    $issuedDate: Date!
    $reportNumber: String
    $validityMonths: Int
    $validUntil: Date
    $productIds: [ID]
    $standardIds: [ID]
    $fileUrls: [String]
  ) {
    createLabTestReport(
      title: $title
      country: $country
      issuer: $issuer
      issuedDate: $issuedDate
      reportNumber: $reportNumber
      validityMonths: $validityMonths
      validUntil: $validUntil
      productIds: $productIds
      standardIds: $standardIds
      fileUrls: $fileUrls
    ) {
      labTestReport {
        id
      }
    }
  }
`;

export const UPDATE_LAB_TEST_REPORT = gql`
  mutation UpdateLabTestReport(
    $id: ID!
    $title: String
    $country: String
    $issuer: String
    $issuedDate: Date
    $reportNumber: String
    $validityMonths: Int
    $validUntil: Date
    $productIds: [ID]
    $standardIds: [ID]
    $fileUrls: [String]
  ) {
    updateLabTestReport(
      id: $id
      title: $title
      country: $country
      issuer: $issuer
      issuedDate: $issuedDate
      reportNumber: $reportNumber
      validityMonths: $validityMonths
      validUntil: $validUntil
      productIds: $productIds
      standardIds: $standardIds
      fileUrls: $fileUrls
    ) {
      labTestReport {
        id
      }
    }
  }
`;

export const DELETE_LAB_TEST_REPORT = gql`
  mutation DeleteLabTestReport($id: ID!) {
    deleteLabTestReport(id: $id) {
      id
    }
  }
`;
